import { render } from "./Cursus.vue?vue&type=template&id=2be4b74e&scoped=true"
import script from "./Cursus.vue?vue&type=script&lang=js"
export * from "./Cursus.vue?vue&type=script&lang=js"

import "./Cursus.vue?vue&type=style&index=0&id=2be4b74e&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be4b74e"]])

export default __exports__